/**
 * Which paths are a staff application rather than a page on the public site.
 *
 * Each of these is a standalone app shell — its own top bar, its own viewport,
 * its own navigation. Public chrome must not render on top of them: not the
 * site header, and not the passenger support chatbot.
 *
 * This lived inline in `SiteHeader` and nothing else read it, so the chatbot
 * kept rendering on the counter admin desk and the POS — a customer support
 * bubble floating over a staff terminal, offering the clerk a passenger's help
 * channel.
 *
 * **Matched on a path-segment boundary, not a raw prefix.** Two bugs live in
 * the naive version:
 *   - a trailing slash (`/counter/`) misses the bare route, which is why the
 *     public header once sat on top of the counter admin desk at `/counter`
 *     while correctly hidden on `/counter/profile`;
 *   - dropping it (`/counter`) then swallows `/counters`, a genuine public
 *     page in the main navigation.
 */
const STAFF_SURFACES = [
  '/admin',
  '/driver',
  '/staff',
  '/counter',
  '/finance',
  '/support-staff',
  '/hr',
  '/pos',
] as const;

export function isStaffSurface(pathname: string): boolean {
  return STAFF_SURFACES.some(
    (route) => pathname === route || pathname.startsWith(`${route}/`),
  );
}
